import React from 'react';
import { EnvelopeIcon, InformationCircleIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

const ContactPage = () => {
  const contactEmails = [
    {
      email: 'info@dersmaster.com',
      title: 'Genel Bilgi',
      description: 'Genel sorularınız ve bilgi talepleriniz için',
      icon: <InformationCircleIcon className="h-8 w-8" />
    },
    {
      email: 'iletisim@dersmaster.com',
      title: 'İletişim',
      description: 'Kurumsal iletişim ve işbirlikleri talepleriniz için',
      icon: <EnvelopeIcon className="h-8 w-8" />
    },
    {
      email: 'destek@dersmaster.com',
      title: 'Destek',
      description: 'Teknik destek ve yardım talepleriniz için',
      icon: <QuestionMarkCircleIcon className="h-8 w-8" />
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white dark:from-gray-900 dark:to-gray-800 py-12 px-4 sm:px-6 lg:px-8">
      <Helmet>
        <title>İletişim | DersMaster - Özel Ders ve Eğitim Platformu</title>
        <meta name="description" content="DersMaster iletişim sayfası. Genel bilgi, kurumsal iletişim ve teknik destek için bize ulaşın." />
        <meta name="keywords" content="iletişim, dersmaster, destek, bilgi, özel ders, eğitim platformu, e-posta, yardım" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="DersMaster" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="İletişim | DersMaster - Özel Ders ve Eğitim Platformu" />
        <meta property="og:description" content="DersMaster iletişim sayfası. Genel bilgi, kurumsal iletişim ve teknik destek için bize ulaşın." />
        <meta property="og:url" content="https://dersmaster.com/contact" />
        <meta property="og:image" content="https://dersmaster.com/logo192.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="İletişim | DersMaster - Özel Ders ve Eğitim Platformu" />
        <meta name="twitter:description" content="DersMaster iletişim sayfası. Genel bilgi, kurumsal iletişim ve teknik destek için bize ulaşın." />
        <meta name="twitter:image" content="https://dersmaster.com/logo192.png" />
        <link rel="canonical" href="https://dersmaster.com/contact" />
        <html lang="tr" />
      </Helmet>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            İletişim
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            Size yardımcı olmaktan mutluluk duyarız
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {contactEmails.map((item, index) => (
            <motion.div
              key={item.email}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow"
            >
              <div className="flex flex-col items-center text-center">
                <div className="text-blue-600 dark:text-blue-400 mb-4">
                  {item.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-300 mb-4 text-sm">
                  {item.description}
                </p>
                <a
                  href={`mailto:${item.email}`}
                  className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 font-medium transition-colors"
                >
                  {item.email}
                </a>
              </div>
            </motion.div>
          ))}
        </div>

        
      </div>
    </div>
  );
};

export default ContactPage;
